const prefix = '/api/v2/basic'

export const name = 'official-account-api-config'

export const api = {
  weChat: {
    freeAccountLogin: `${prefix}/purchaser/account/login/free`, // get
    discern: `${prefix}/purchaser/we-chat/ticket/discern`, // post
    sendCode: `${prefix}/purchaser/account/login/code/send`, // get
    checkAuthCode: `${prefix}/purchaser/account/login/code/check`, // get
    listAccountbyMobile: `${prefix}/purchaser/account-list/mobile`, // post query
    getInvoiceList: `${prefix}/purchaser/we-chat/ticket/page`, // get
    nonVatSaveAndCommit: `${prefix}/purchaser/we-chat/non-vat/save-commit`, // post
    nonVatSave: `${prefix}/purchaser/we-chat/non-vat/save`, // post
    vatSaveAndCommit: `${prefix}/purchaser/we-chat/vat/save-commit`, // post
    vatSave: `${prefix}/purchaser/we-chat/vat/save`, // post
    nonVatUpdate: `${prefix}/purchaser/we-chat/non-vat/edit`, // put
    nonVatCommit: `${prefix}/purchaser/we-chat/non-vat/commit`, // put
    nonVatEditAndCommit: `${prefix}/purchaser/we-chat/non-vat/edit-commit`, // put
    nonVatDel: `${prefix}/purchaser/we-chat/non-vat/delete/:id`, // delete :id
    vatUpdate: `${prefix}/purchaser/we-chat/vat/edit`, // put
    vatCommit: `${prefix}/purchaser/we-chat/vat/commit`, // put
    vatEditAndCommit: `${prefix}/purchaser/we-chat/vat/edit-commit`, // put
    vatDel: `${prefix}/purchaser/we-chat/vat/delete/:id`, // delete :id
    getNonVat: `${prefix}/purchaser/we-chat/non-vat/:id`, // get :id
    getVat: `${prefix}/purchaser/we-chat/vat/:id`, // get :id
    vatCheck: `${prefix}/purchaser/we-chat/vat/check/:id`, // put
    getOffiaccountSignature: `${prefix}/purchaser/account/signature/get` // get
  }
}
